//获取noteList ，这里将会根据 state.show的状态做数据过滤
export const filterNotes=(state)=>{
    if(state.show==="all"){
        return state.notes || {} ;
    }else if(state.show==="favorite"){
        return state.notes.filter(note=>note.favorite) || {};
    }
};
//------------------------getters 定义规则说明-----------------------
//      getters  旨在 为 state 提供 数据代理，应该尽量避免业务逻辑
//      getters 命名：驼峰（实体名）
//---------------------------------------------------------------------

//获取全局URL
export const appUrl=(state)=>{return state.appUrl;}
export const idcUrl=(state)=>{return state.idcUrl;}
//----------------- 卡券系统 ---------------------------------
export const specModule=(state)=>{   return state.specModule;}
export const activeTab=(state)=>{   return state.activeTab;}
export const SessionTabList=(state)=>{   return state.SessionTabList;}
//----------------1.菜单--menuList--------------------
// 1.1 菜单信息
export const menuList=(state)=>{   return state.menuList;}

//-----------------2.用户--sessionUser---------------------
// 2.1 当前用户
export const sessionUser=(state)=>{   return state.sessionUser;}

//-----------------3.报表--stdQuery---------------------
//3.1 queryName
export const queryName=(state)=>{    return state.queryName;}
//3.2查询参数
export const queryParams=(state)=>{   return state.queryParams;}
//3.2.2 查询参数配置数据
export const queryParamConfigData=(state)=>{   return state.queryParamConfigData;}
//3.3查询结果
export const queryData=(state)=>{   return state.queryData;}
//3.4弹出框 queryName
export const smallQueryName=(state)=>{  return state.smallQueryName;}
//3.5弹出框配置数据
export const smallQueryConfigData=(state)=>{  return state.smallQueryConfigData;}
//3.6弹出框查询结果 总条数
export const smallQueryTotalCount=(state)=>{  return state.smallQueryTotalCount;}
//3.7弹出框查询结果
export const smallQueryData=(state)=>{  return state.smallQueryData;}
//3.8弹出框查询结果
export const smallQueryType=(state)=>{  return state.smallQueryType;}
//3.9 分页对象
export const pageObject=(state)=>{  return state.pageObject;}
 //3.10 SmallQueryHideParam 弹出框隐藏参数
export const  SmallQueryHideParam=(state)=>{  return state.SmallQueryHideParam;}
//3.11
export const autoExec=(state)=>{return state.autoExec;}
//-----------------4.模块--stdModule---------------------
//4.1.1 模块配置数据
export const moduleConfigData=(state)=>{ return state.moduleConfigData;}
//4.1.2 dataList复制容器，以便清空
export const dataListCopy=(state)=>{ return state.dataListCopy;}
//4.2 当前审核步骤 auditStep
export const auditStep=(state)=>{ return state.auditStep;}
//4.3 //模块4种状态：Normal（默认），Add，Modify，Del
export const ModuleState=(state)=>{ return state.ModuleState;}
//4.4 模态框回显值
export const smallQueryReturnVal=(state)=>{ return state.smallQueryReturnVal;}
//4.5 业务标记 BusPowID
export const BusPowID=(state)=>{ return state.BusPowID;}
//4.6 双击查询单据详情 DataObject
export const DataObject=(state)=>{ return state.DataObject;}
//4.7 当前Grid Tab编号 TabId_Now
export const TabId_Now=(state)=>{ return state.TabId_Now;}
// 4.8 dataObject 参数 带值
export const dataObjectParams =(state)=>{ return state.dataObjectParams;}
//5.0  业务执行结果
export const bizQueryBatchData = (state)=>{return state.bizQueryBatchData;}

//5.1 报表模块初化化DATA
export const stdQueryConfigData = (state)=>{return state.stdQueryConfigData};
//5.2 报表查询条件
export const reportQueryParamsData= (state)=>{return state.reportQueryParamsData;}

//-----------------5. 首页--home---------------------
//5.0 首页数据
export const homeData= (state)=>{return state.homeData;}
//5.1 订单统计
export const WaitOrder= (state)=>{return state.WaitOrder;}
//5.2 退单统计
export const WaitReturnOrder= (state)=>{return state.WaitReturnOrder;}
//5.3 实时数据
export const CurrentOrder= (state)=>{return state.CurrentOrder;}
//5.4 业绩环比统计
export const RoundRatio= (state)=>{return state.RoundRatio;}
//5.5 店铺销售前十统计
export const ShopSaleRank= (state)=>{return state.ShopSaleRank;}
//5.6 商品销售前十统计
export const GoodsSaleRank= (state)=>{return state.GoodsSaleRank;}
//5.7 品类销售占比统计
export const CategoryRatio= (state)=>{return state.CategoryRatio;}
//5.8 区域周销售统计
export const WeekSaleCompare= (state)=>{return state.WeekSaleCompare;}
//echarsTheme主题
export const echarsTheme=(state)=>{return state.echarsTheme;}

//系统信息
export const systemInfo=(state)=>{return state.systemInfo;}
//加载动画
export const showEleLoading=(state)=>{return state.showEleLoading;}
//弹出层表格加载动画
export const showSmallEleLoading=(state)=>{return state.showSmallEleLoading;}

//eltable 操作按钮
export const  operationButtonInitData=(state)=>{return state.operationButton;}

//父组件为smallQuery查询时预设置的查询参数
export const  smallQueryAddParamByParentData=(state)=>{return state.smallQueryAddParamByParent;}
//6.5 获取 B00005 模块  根据条码找出的基础资料信息，供第二步 匹配
export const  GetMainBarGodeGoodsData=(state)=>{return state.mainBarCodeGoodsData;}

//a00003模块系统参数信息获取
export const  GetSysParamsInfo=(state)=>{return state.sysParamsInfo;}
export const  GetTableData=(state)=>{return state.tableData;}

//6.6 B00005 模块 获取商品分类
export const  getGoodsCategoryData = (state) => {
    const category = state.goodsCategory
    if(!category.data)return[[],[],[]]
    const firstMenus = category.data.dataList.filter(function(val){
        if (val.NO === '00'){
            return false
        }
        return val.NO.length === 2
    })
    const secondMenus = category.data.dataList.filter(function(val){
        return val.NO.length === 4
    })
    const thirdMenus = category.data.dataList.filter(function(val){
        return val.NO.length === 6
    })
    return [ firstMenus, secondMenus, thirdMenus ]
}
//6.7 获取B0005模块 根据条码获得的图片信息
export const getGoodsPictureDate = (state) => {
    const imgUrl = 'http://img.egolm.com'
    let picture = state.goodsPicture
    let showFileList = []
    let detailFileList = []
    if (!picture.data) return { showFileList, detailFileList }
    let showImage = picture.data.dataList.filter( (val) => {
        return val.PicTypeID === '1'
    } )
    let detailImage = picture.data.dataList.filter( (val) => {
        return val.PicTypeID === '2'
    } )
    showImage.forEach(function(el, index) {
        let obj = Object.create(null)
        obj.name = el.MainBarcode + 'img-' +index
        obj.url = imgUrl + el.URL
        obj.GoodsID = el.GoodsID
        obj.idx = index
        this.push(obj)
    }, showFileList);
    detailImage.forEach(function(el, index) {
        let obj = Object.create(null)
        obj.name = el.MainBarcode + 'img-' +index
        obj.url = imgUrl + el.URL
        obj.GoodsID = el.GoodsID
        obj.idx = index
        this.push(obj)
    }, detailFileList)
    console.log(showFileList)
    return { showFileList, detailFileList }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js